import { z } from "zod";

export const memberFormSchema = z.object({
  name: z.string().min(1, "Provider name is required"),
  npi: z.string().optional(),
  specialtyCode: z.string().min(1, "A specialty must be chosen"),
  specialtyCodeDisplay: z.string(),
  specialtyCodeSystem: z.string(),
});
